"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _DataAuthorize = _interopRequireDefault(require("@rsuite/icon-font/lib/application/DataAuthorize"));

// Generated by script, don't edit it please.
var DataAuthorize = (0, _createSvgIcon["default"])({
  as: _DataAuthorize["default"],
  ariaLabel: 'data authorize',
  category: 'application',
  displayName: 'DataAuthorize'
});
var _default = DataAuthorize;
exports["default"] = _default;
module.exports = exports.default;